import { Box, Typography } from "@mui/material";

export default function HeroWave({ image, h3, h6, hidBanner }) {
  return (
    <>
    {hidBanner === true ? <Box
      component="section"
      sx={{ position: "relative", width: "100%", overflow: "hidden" }}
    >
      <Box
        component="img"
        src={image}
        alt="合作資訊"
        sx={{ width: "100%", height: "auto", display: "block" }}
      />

      <Box
        sx={{
          position: "absolute",
          // position scales a bit with viewport, keeping a nice composition
          top: { xs: "12%", sm: "14%", md: "22%" },
          left: { xs: "4%", sm: "6%", md: "18%" },
          right: { xs: "4%", sm: "6%", md: "auto" },
          color: "#000",
        }}
      >
        {/* H3: fluid font-size with sane min/max */}
        <Typography
          component="h1"
          sx={{
            fontWeight: 700,
            lineHeight: 1.15,
            fontFamily: "LINE Sans TW",
            // min 20px, ideal ~6vw, max 42px on large screens
            fontSize: { xs: "clamp(20px, 6vw, 14px)", md: "clamp(28px, 3.6vw, 42px)" },
            letterSpacing: { xs: 0.2, md: 0.4 },
          }}
        >
          {h3}
        </Typography>

        {/* H6: fluid as well, slightly smaller */}
        <Typography
          component="p"
          sx={{
            mt: 0.75,
            lineHeight: 1.5,
            fontWeight: 400,
            fontFamily: "LINE Sans TW",
            fontSize: { xs: "clamp(12px, 3.5vw, 8px)", md: "clamp(16px, 1.6vw, 20px)" },
            letterSpacing: { xs: 0.2, md: 0.3 },
            maxWidth: { xs: "92%", sm: "80%", md: 640 }, // keep to readable width
            // optional: subtle shadow if your hero image is bright
            // textShadow: "0 1px 3px rgba(255,255,255,.6)"
          }}
        >
          {h6}
        </Typography>
      </Box>
    </Box> : <></>}
    </>
    
  );
}
